import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '../overlay/Dialog';
import TextField from 'material-ui/TextField';
import AutoComplete from 'material-ui/AutoComplete';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Checkbox from 'material-ui/Checkbox';
import OverlayController from '../overlay/OverlayController';
import _ from 'lodash';
import './QueueButtonDialog.css'


export default class QueueButtonDialog extends React.Component {

    static propTypes = {
        button: PropTypes.object,
        project: PropTypes.object,
        didAddButton: PropTypes.func,
        didEditButton: PropTypes.func
    };

    constructor(props) {
        super(props);

        let availableEventNames = new Set();
        let transitionEventsById = _.keyBy(props.project.transitionEvents, 'id');
        props.project.transitions.forEach(transition => {
            availableEventNames.add(transitionEventsById[transition.transitionEventId].name);
        });

        this.state = {
            availableEventNames: [...availableEventNames],
            buttonId: props.button ? props.button.id : null,
            buttonTitle: props.button ? props.button.title : '',
            eventName: props.button ? (props.button.eventName || '') : '',
            assignCurrentUser: props.button ? !!props.button.flowIdForUserAssignment : false,
            flowIdForUserAssignment: props.button ? props.button.flowIdForUserAssignment : null,
            showEventNameError: false
        };
    }

    didClickSave(event) {
        event.preventDefault();
        if (!this.isDoneButtonEnabled()) {
            return;
        }
        let id = this.state.buttonId;
        let title = this.state.buttonTitle.trim();
        let eventName = this.isEventNameValid(this.state.eventName) ? this.state.eventName : null;
        let flowIdForUserAssignment = this.state.flowIdForUserAssignment;
        if (id) {
            this.props.didEditButton({
                id,
                title,
                eventName,
                flowIdForUserAssignment
            });
        } else {
            this.props.didAddButton({
                title,
                eventName,
                flowIdForUserAssignment
            });
        }
        // Hide this dialog
        OverlayController.hideOverlay();
    }

    onChangeButtonTitle(event) {
        let buttonTitle = event.target.value;
        this.setState({
            buttonTitle: buttonTitle
        });
    }

    onEventNameUpdate(eventName) {
        this.updateStateForEventName(eventName, false);
    }

    onEventNameNewRequest(eventName) {
        eventName = typeof eventName === "string" ? eventName : eventName.text;
        this.updateStateForEventName(eventName, true);
    }

    onEventNameBlur(event) {
        let eventName = event.target.value;
        this.updateStateForEventName(eventName, true);
    }

    updateStateForEventName(eventName, showError) {
        if (this.isEventNameValid(eventName)) {
            this.setState({
                eventName: eventName,
                showEventNameError: false
            });
        } else {
            this.setState({
                eventName: eventName,
                showEventNameError: eventName === '' ? false : showError
            });
        }
    }

    onFlowChange(event, index, value) {
        this.setState({
            flowIdForUserAssignment: value
        });
    }

    onCurrentUserChange(event, isInputChecked) {
        this.setState({
            assignCurrentUser: isInputChecked,
            flowIdForUserAssignment: null
        });
    }

    isDoneButtonEnabled() {
        let hasButtonTitle = this.state.buttonTitle.trim().length !== 0;
        let hasValidEventName = this.isEventNameValid(this.state.eventName);
        let hasPickedFlowOrNoFlow = !this.state.assignCurrentUser || this.state.flowIdForUserAssignment;
        return hasButtonTitle && hasValidEventName && hasPickedFlowOrNoFlow;
    }

    isEventNameValid(eventName) {
        let index = this.state.availableEventNames.findIndex(_eventName => (_eventName === eventName));
        return index !== -1;
    }

    render() {
        let actions = [
            {label: 'Cancel', handler: () => OverlayController.hideOverlay()},
            {label: 'Done', type: "submit", form: "queueButtonForm", disabled: !this.isDoneButtonEnabled()}
        ];
        let dataSource = this.state.availableEventNames.map(eventName => ({
            text: eventName,
            value: <MenuItem primaryText={eventName} />
        }));
        return (
            <Dialog title="Add Action Button" actions={actions} className="queue-button-dialog">
                <form onSubmit={this.didClickSave.bind(this)} id="queueButtonForm">
                    <TextField
                        className="custom-field"
                        fullWidth={true}
                        floatingLabelText="Button Title"
                        floatingLabelFixed={true}
                        hintText="Enter title for the button"
                        value={this.state.buttonTitle}
                        onChange={this.onChangeButtonTitle.bind(this)}
                    />
                    <AutoComplete
                        className="custom-field"
                        fullWidth={true}
                        floatingLabelText="Event Name"
                        floatingLabelFixed={true}
                        hintText="Enter name of the event this button will trigger"
                        searchText={this.state.eventName}
                        openOnFocus={true}
                        dataSource={dataSource}
                        onUpdateInput={this.onEventNameUpdate.bind(this)}
                        onNewRequest={this.onEventNameNewRequest.bind(this)}
                        onBlur={this.onEventNameBlur.bind(this)}
                        errorText={this.state.showEventNameError ? "Event not found" : null}
                        filter={(searchText, key) => key.indexOf(searchText) !== -1}
                        style={{display: "block", width: "auto"}}>
                    </AutoComplete>
                    <Checkbox
                        className="assign-current-user-checkbox"
                        label="Assign to Current User"
                        onCheck={this.onCurrentUserChange.bind(this)}
                        checked={this.state.assignCurrentUser}/>
                    {this.state.assignCurrentUser &&
                    <SelectField
                        className="custom-field custom-select-field"
                        fullWidth={true}
                        floatingLabelText="Flow for assignment"
                        floatingLabelFixed={true}
                        hintText="Choose flow"
                        value={this.state.flowIdForUserAssignment}
                        onChange={this.onFlowChange.bind(this)}>
                        <MenuItem value={null} primaryText=""/>
                        {this.props.project.flows.map(flow =>
                            <MenuItem key={flow.id} value={flow.id} primaryText={flow.name}/>
                        )}
                    </SelectField>
                    }
                </form>
            </Dialog>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/queue/QueueButtonDialog.js